define('models/PaymentGroupCollection',['underscore','ObjectCollection','LocalStorage',
    'models/PaymentModeCollection',
    'models/PaymentGroupModel',
],function (
        _,ObjectCollection,LocalStorage,
        PaymentModeCollection,
        PaymentGroupModel
) {
    //
    // Collection PaymentGroup
    //
    var PaymentGroupCollectionPrototype = {
        
        name:'PaymentGroupCollection',
        route:'apiPaymentGroupCollection',
        model:PaymentGroupModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(this,arguments);
       },

        setup:function(){
            this.each(function(paymentGroup){
                paymentGroup.setup();
            })
        },

        getPaymentModes:function(){
              var paymentModes = new PaymentModeCollection();
              this.each(function(paymentGroup){
                  var paymentGroupModes = paymentGroup.getPaymentModes();
                  paymentGroupModes.each(function(paymentMode){
                      paymentModes.push(paymentMode);
                  })
              })
            return paymentModes;
        },

        getPaymentMode:function(id_payment_mode){
            var paymentMode;
            this.each(function(paymentGroup){
                var paymentModeModel = paymentGroup.getPaymentMode(id_payment_mode);
                if(paymentModeModel) paymentMode = paymentModeModel;
            })
            return paymentMode;
        }
    };

    var PaymentGroupCollection = ObjectCollection.extend(LocalStorage).extend(PaymentGroupCollectionPrototype);

    return PaymentGroupCollection;
});
